export default {
  getLeads ({ leads }) {
    return leads
  },

  getDesempenho ({ desempenho }) {
    return desempenho
  },

  getRankNovos ({ rankNovos }) {
    return rankNovos
  },

  getRankLeads ({ rankLeads }) {
    return rankLeads
  },

  getRankUsados ({ rankUsados }) {
    return rankUsados
  },

  getRankConsorcio ({ rankConsorcio }) {
    return rankConsorcio
  },

  getHistoricoRank ({ historicoRank }) {
    return historicoRank
  },

  getEmpresas ({ empresas }) {
    return empresas
  }
}
